import { ApiError } from '@libs-uuif/shared/api-service';
import router from '@/router';
import ApiServiceWrapper from '@/shared/api-request.service';
import idb from '@/services/indexedDb.service';
import { i18nService } from '@sonicwall/unified-ui-framework/src/shared/i18n-service';

class MSWHttpInterceptor {
  handleError(error: ApiError) {
    try {
      if (error!.response! .status === 401) {
        if (!ApiServiceWrapper.$route.currentRoute.query!.redirectURL) {
          console.warn('401 error');
          const redirectedUrl = btoa(ApiServiceWrapper.$route.currentRoute.fullPath);
        // router.push(`/login?redirectURL=${redirectedUrl}`);
          if (window.top.location.href.indexOf('workspace/m/feature/spog-homepage') > -1) {
            window.top.location.href = `${window.top.location.origin}/muir/spog/login`;
          } else if (ApiServiceWrapper.$store.getters.getHideNavStatus !== 'APP') {
            router.push(`/login?redirectURL=${redirectedUrl}`);
          } else {
            window.top.location.href = `${window.top.location.origin}/muir/login`;
          }
        }
        idb.clearData()
      .then(() => {
        console.warn('indexedDb cleared');
      });
      }
      ApiServiceWrapper.$store.commit('stopLoading');
    } catch (e) {
      ApiServiceWrapper.$store.commit('stopLoading');
    }
  }
  modifyErrorMessage(error: ApiError) {
    if (error &&
      error.response &&
      error.response.status === 504) {
      error.message = i18nService
        .i18n
        .t('common.errorOccured')
        .toString();
    }
    return error;
  }
}

export default new MSWHttpInterceptor();
